import { render } from "./MentionsLegalesPage.vue?vue&type=template&id=6e8cb2c9&scoped=true"
import script from "./MentionsLegalesPage.vue?vue&type=script&lang=js"
export * from "./MentionsLegalesPage.vue?vue&type=script&lang=js"

import "./MentionsLegalesPage.vue?vue&type=style&index=0&id=6e8cb2c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8cb2c9"]])

export default __exports__